module.exports = __webpack_public_path__ + "static/media/MONITOREO-ESTRATEGICO.dd1d5214.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/MONITOREO-ESTRATEGICO.png
// module id = 281
// module chunks = 0